export const isFAImported = (b) => typeof b?.external_ref === "string" && b.external_ref.startsWith("fa:");

const VARIANT_CLASSES = {
  // Default: readable on the dark app surface
  default: "bg-blue-500/20 text-blue-400 border border-blue-500/40",
  // Solid: readable on any colour (calendar cells, printed poster)
  solid: "bg-[#0F172A] text-[#83B68B] border border-[#0F172A]",
  // Light: for the printed white poster sheet
  light: "bg-[#0F172A] text-[#83B68B] border border-[#0F172A]",
};

const SIZE_CLASSES = {
  xs: "text-[9px] px-1 py-[1px] leading-none",
  sm: "text-[9px] px-1.5 py-0.5",
};

export const FABadge = ({ variant = "default", size = "sm", className = "", testId }) => (
  <span
    data-testid={testId || "fa-badge"}
    title="Imported from FA Full-Time"
    className={`inline-flex items-center font-black tracking-widest uppercase rounded ${VARIANT_CLASSES[variant] || VARIANT_CLASSES.default} ${SIZE_CLASSES[size] || SIZE_CLASSES.sm} ${className}`}
  >
    FA
  </span>
);

export default FABadge;
